import misc from './misc'
import users from './users'
import surveys from './surveys'
import dietitians from './dietitians'
import files from './files'
import groups from './groups'
import subscriptions from './subscriptions'
import login from './login'
import signup from './signup'
import messaging from './messaging'
import profile from './profile'

export default {
  misc,
  users,
  surveys,
  dietitians,
  files,
  groups,
  subscriptions,
  login,
  signup,
  messaging,
  profile
}



// WEBPACK FOOTER //
// ./src/app/store/index.js